import { render } from "./DashIcon.vue?vue&type=template&id=0a8b8d6c&scoped=true"
import script from "./DashIcon.vue?vue&type=script&lang=js"
export * from "./DashIcon.vue?vue&type=script&lang=js"

import "./DashIcon.vue?vue&type=style&index=0&id=0a8b8d6c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a8b8d6c"]])

export default __exports__